
import Vue from "vue";
import { BaseButton } from "@/@shell/components/BaseButton/BaseButtonInterface";

export default Vue.extend({
  props: {
    tooltip: {
      type: Object as () => BaseButton,
      required: false,
    },
  },
  methods: {
    handleClick(e: Event) {
      // also emits the event to allow event methods to be launched
      this.$emit("click", e);
    },
  },
});
